import { useTranslation } from "next-i18next";

const HOMEPAGE_V2_NAMESPACES = ["homepageV2", "mktCardV2", "load-form", "navigation", "common"] as const;

export const useHomepageV2Translation = () => {
    const { t, i18n } = useTranslation(HOMEPAGE_V2_NAMESPACES);

    return { t, i18n };
};

export default useHomepageV2Translation;
